import FJMobileQuantity from './FJMobileQuantity';
import { useSelector, useDispatch } from 'react-redux';
import FJActionImageToImage from '../../../redux/action/FJActionImageToImage';
import useLocalStore from '../../../hooks/useLocalStore';
const FJMobileQuantityContainer = () => {
    const dispatch = useDispatch();
    useLocalStore();

    const generateQuantity = useSelector(state => state.imageToImage.generateQuantity);
    const changeGenerateQuantity = num => {
        dispatch(FJActionImageToImage.updateGenerateQuantityAction(num));
    };

    return <FJMobileQuantity generateQuantity={generateQuantity} changeGenerateQuantity={changeGenerateQuantity} />;
};
export default FJMobileQuantityContainer;
